import IconResizer from "../icon/IconResizer"
import CheckIcon from "../icon/CheckIcon"
import { useState } from "react"

interface CheckBoxProps {
    children: string
    initial: boolean
    onChange?: (val: boolean) => void
}

function CheckBox(props: CheckBoxProps) {
    const size = 20

    const [state, setState] = useState<boolean>(props.initial)
    function onToggle() {
        if (props.onChange) props.onChange(!state)
        setState(!state)
    }

    return (
        <div className={"w-full flex items-center space-x-4"}>
            <div
                onClick={onToggle}
                className={
                    "border border-neutral-200 rounded flex items-center justify-center hover:bg-neutral-100 cursor-pointer hover:border-blue-600"
                }
                style={{
                    width: size,
                    minWidth: size,
                    height: size,
                    minHeight: size
                }}>
                <div
                    style={{
                        marginLeft: -10,
                        marginTop: -10
                    }}>
                    {state && (
                        <IconResizer size={10} color={"text-neutral-500"}>
                            <CheckIcon />
                        </IconResizer>
                    )}
                </div>
            </div>
            <div>{props.children}</div>
        </div>
    )
}

export default CheckBox
